<!--
 * @Author: 仙道
 * @Date: 2023-04-16 14:39:11
 * @LastEditTime: 2023-05-08 23:18:40
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/duty/tabPage.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="9" :md="10" :sm="24" :xl="8">
            <a-form-item label="值班开始时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                :show-time="{ format: 'HH:mm:ss' }"
                @change="onDateChange"
                @ok="onDateChange"
                format="YYYY-MM-DD HH:mm:ss"
                v-model="timeRange"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="值班长">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                @select="searchQuery"
                placeholder="请选择负责人"
                type="list"
                v-model="queryParam.manager"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button :disabled="!allowDutyShift" @click="handleAdd" icon="plus" type="primary">交接班</a-button>
      <a-button @click="handleExportXls('值班记录')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
    </div>

    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="ipagination"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :scroll="{ x: true }"
      @change="handleTableChange"
      bordered
      class="j-table-force-nowrap"
      ref="table"
      rowKey="id"
      size="middle"
    >
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="imgSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
        <img
          :src="getImgView(text)"
          alt
          height="25px"
          style="max-width:80px;font-size: 12px;font-style: italic;"
          v-else
        />
      </template>
      <template slot="fileSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
        <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
          >下载</a-button
        >
      </template>

      <span slot="action" slot-scope="text, record">
        <a @click="showDesigner(record)">值班日志</a>
        <a-divider type="vertical"></a-divider>
        <a @click="showStatReport(record, 'dutyReport')" v-if="!!record.endTime">交班记录</a>
      </span>
    </a-table>
    <yw-duty-record-modal @ok="modalFormOk" ref="modalForm"></yw-duty-record-modal>

    <yw-duty-record-form-modal @ok="modalDesignerOk" ref="modalDesigner" />
    <iframe-drawer :width="1100" ref="iframeDrawer"></iframe-drawer>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { httpAction, getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import YwDutyRecordModal from './modules/YwDutyRecordModal'
import YwDutyRecordFormModal from './modules/YwDutyRecordFormModal.vue'

export default {
  name: 'YwDutyRecordListPage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    YwDutyRecordModal,

    YwDutyRecordFormModal
  },
  data() {
    return {
      description: '值班记录管理页面',
      isorter: {
        column: 'startTime',
        order: 'desc'
      },
      allowDutyShift: false,
      // 表头
      columns: [
        {
          title: '值班编号',
          align: 'center',
          dataIndex: 'dutyCode'
        },
        {
          title: '值班人员',
          align: 'center',
          dataIndex: 'manager_dictText'
        },
        {
          title: '值班开始时间',
          align: 'center',
          sorter: true,
          dataIndex: 'startTime'
        },
        {
          title: '值班结束时间',
          align: 'center',
          dataIndex: 'endTime'
        },
        {
          title: '接班人员',
          align: 'center',
          dataIndex: 'successor_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/duty/dutyRecord/list',
        delete: '/duty/dutyRecord/delete',
        deleteBatch: '/duty/dutyRecord/deleteBatch',
        exportXlsUrl: '/duty/dutyRecord/exportXls',
        importExcelUrl: 'duty/dutyRecord/importExcel',
        getReportUrl: '/custom/commonOnlReport/list'
      },
      dictOptions: {},
      superFieldList: [],
      reportUrl: {},
      timeRange: []
    }
  },
  created() {
    this.getSuperFieldList()
    this.getDutyingPerson()

    const that = this
    getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
      if (res.success && res.result) {
        res.result.records.forEach(rep => {
          that.reportUrl[rep.shortName] = rep.url
        })
      }
    })
  },
  methods: {
    showDesigner: function(record) {
      const title = `值班记录【开始时间：${record.startTime}】-【值班人员：${record.manager_dictText}】`
      this.$refs.modalDesigner.edit(record)
      this.$refs.modalDesigner.title = title
      this.$refs.modalDesigner.disableSubmit = !!record.endTime
    },
    modalDesignerOk() {
      this.$refs.modalDesigner.close()
    },
    handleAdd: function() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '交接班'
      this.$refs.modalForm.disableSubmit = false
    },
    getDutyingPerson() {
      getAction(this.url.list, {
        column: 'startTime',
        order: 'desc',
        pageNo: 1,
        pageSize: 1
      }).then(res => {
        if (res.success) {
          const records = res.result.records
          if (records.length === 0) {
            this.allowDutyShift = true
            return
          }
          if (records[0].endTime) {
            this.allowDutyShift = true
            return
          }
          if (records[0].manager === this.$store.getters.userInfo.id) {
            this.allowDutyShift = true
            return
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onDateChange: function(value, dateString) {
      this.queryParam.startTime_begin = dateString[0]
      this.queryParam.startTime_end = dateString[1]
      this.searchQuery()
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData()
      // 清空列表选中
      this.onClearSelected()
      this.getDutyingPerson()
    },
    showStatReport(record, reportKey) {
      let url = this.reportUrl[reportKey]
      if (!url) {
        this.$message.warning('未找到统计信息配置')
      }
      url += `&dutyid=${record.id}&startTime=${record.startTime}&endTime=${record.endTime || ''}&tenant_id=${
        record.tenantId
      }`
      this.$refs['iframeDrawer'].show(url)
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'dutyCode', text: '值班编号', dictCode: '' })
      fieldList.push({ type: 'datetime', value: 'startTime', text: '值班开始时间' })
      fieldList.push({ type: 'datetime', value: 'endTime', text: '值班结束时间' })
      fieldList.push({ type: 'string', value: 'manager', text: '值班长', dictCode: '' })
      fieldList.push({ type: 'string', value: 'confirmation', text: '接班确认', dictCode: '' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
